import React, {useEffect,useState} from 'react'
import {
  Button,
  Form,
  Input,
  message,
  Select,
  Upload,
  Radio
} from 'antd';
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SERVER_ADDRESS } from '../../../Config/Config';
const { Dragger } = Upload;

const {Option} = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const AddIcon = () => {
    const[form]=Form.useForm();
    const [categories, setCategories] = useState([]);
    const [styles, setStyles] = useState([]);
    const [fileList, setfileList] = useState([]);
    const navigate = useNavigate();
    const [uploadType, setUploadtype] = useState('bulk')
    const [loading, setLoading] = useState(false)
    //Fetch category
      useEffect(() => {
        const fetchCategories = async () => {
           try {
             const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`); 
             setCategories(response.data); 
           } catch (error) {
             message.error("Failed to fetch categories");
             console.error(error);
           }
         };
         fetchCategories();
       }, []);
    
    //Fetch Style
    useEffect(() => {
        const fetchstyles = async () =>{
            try {
                const response = await axios.get(`${SERVER_ADDRESS}/api/style-list`);
                setStyles(response.data);
            } catch (error) {
                message.error({content:'Cannot fetch style', duration:2})
                console.log(error)
            }
        };
        fetchstyles();
    },[]) 
    
    const handleIconSubmit = async (values) => {
        if (!fileList.length) {
          message.error('Please upload at least one icon file!');
          return;
        }
    
        const formData = new FormData();
    
        // Append form fields to FormData
        Object.keys(values).forEach((key) => {
          formData.append(key, values[key]);
        });
    
        // Append files to FormData
        fileList.forEach((file) => {
          formData.append('icon_files', file.originFileObj);
        });
        
        try {
          const response = await axios.post(`${SERVER_ADDRESS}/api/add-icons`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          message.success('Icons added successfully!');
          form.resetFields();
          setfileList([]);
          navigate('/frontend/dashboard/icon/icon-list');
        } catch (error) {
          console.error('API Error:', error);
          message.error('Failed to add icons');
        }
      };
      
      const handleExcelSubmit = async (values) =>{
        if (!fileList.length) {
          message.error('Please upload an Excel file!');
          return;
        }

        const formData = new FormData();

        fileList.forEach((file) => {
          formData.append('excel_file', file.originFileObj);
        });

        try {
          setLoading(true)
            const response = await axios.post(`${SERVER_ADDRESS}/api/excel-upload`,formData,{
              headers:{
                'Content-Type':'multipart/form-data'
              }
            })
            if (response.data.error) {
              message.error({ content: response.data.error, duration: 2 });
          } else {
              navigate('/frontend/dashboard/icon/icon-list');
              message.success({ content: 'Icon added successfully', duration: 2 });
              form.resetFields();
              setfileList([]);
          }
        } catch (error) {
          if (error.response && error.response.data.error) {
            message.error({ content: error.response.data.error, duration: 2 });
        } else {
            message.error({ content: 'Internal server error', duration: 2 });
        }
        }
        finally{
          setLoading(false)
        }
      }

    // File upload props
    const onChange = ({ fileList: newFileList }) => {
        setfileList(newFileList);
      };

  return (
    <div style={{
        marginTop:'5rem',
      }}>
        <div style={{
          fontSize:'2rem'
        }}>
          Fill Details
        </div>
        <Radio.Group
          onChange={(e)=>setUploadtype(e.target.value)}
          value={uploadType}
          style={{marginBottom:'1rem'}}
        >
          <Radio value="bulk">Bulk Upload</Radio>
          <Radio value="excel">Excel Upload</Radio>
        </Radio.Group>
      {uploadType==='bulk' ? ( <Form
      
        form={form}
      style={{
        backgroundColor:'white',
        width:'60rem',
        marginTop:'1rem',
        padding:'2rem',
        justifySelf:'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius:'0.6rem'
      }}
      labelCol={{
        xs: { span: 24 },
        sm: { span: 6 },
      }}
      wrapperCol={{
        xs: { span: 24 },
        sm: { span: 14 },
      }}
      // labelCol={{span: 3}}
      // wrapperCol={{span:14,offset:2}}
      onFinish={handleIconSubmit}
  >   
        <Form.Item label="Icon Name" name="icon_name" rules={[{ required: true, message: 'Enter the style name' }]} ><Input placeholder="Enter Icon name"></Input></Form.Item>
        <Form.Item label="Category" name="category_id" rules={[{required:true, message:'Select the category'}]}>
            <Select placeholder="Select a category">
                {categories.map((category)=>(
                    <Option key={category.category_id} value={category.category_id}>{category.category_name}</Option>
                ))}
            </Select></Form.Item>
        <Form.Item label="Style" name="style_id" rules={[{required:true, message:'Select the style'}]} >
                <Select placeholder="Select the style" >
                    {styles.map((style)=>(
                        <Option key={style.style_id} value={style.style_id}>{style.style_name}</Option>
                    ))}
                </Select>
        </Form.Item>
        <Form.Item label="Icon Type" name="icon_type_id" rules={[{required:true, message:'Select the Icon Type'}]} >
                <Select placeholder="Select the Icon Type" >
                    <Option key={2} value={2}>Static</Option>
                    <Option key={1} value={1}>Animation</Option>
                </Select>
        </Form.Item>
        <Form.Item label="License" name="license_id" rules={[{required:true, message:'Select the License'}]} >
                <Select placeholder="Select the License" >
                    <Option key={1} value={1}>Free</Option>
                    <Option key={2} value={2}>Premium</Option>
                </Select>
        </Form.Item>
        <Form.Item label="Sort By" name="sort_by_id" rules={[{required:true, message:'Select the Sort By'}]} >
                <Select placeholder="Select the Sort By" >
                    <Option key={1} value={1}>Popular</Option>
                    <Option key={2} value={2}>Recent</Option>
                </Select>
        </Form.Item>
        <Form.Item label="Upload Icon" rules={[{ required: true, message: 'Please upload an icon file!' }]} >
            <Upload name='icons[]' accept='.svg' showUploadList={{showPreviewIcon:false,showRemoveIcon:true}} onChange={onChange} listType='picture-card' multiple beforeUpload={()=>false} >
                    <Button style={{background:'none',border:'0'}} type="button">
                        <PlusOutlined />
                        Upload
                    </Button>
                </Upload>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
  
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>  
      </Form>) : (
        <Form 
        form={form}
        style={{
          backgroundColor:'white',
          width:'60rem',
          marginTop:'1rem',
          padding:'2rem',
          justifySelf:'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius:'0.6rem'
        }}
        onFinish={handleExcelSubmit}
        >
          <Form.Item>
          <Dragger
            name='file'
            accept='.xlsx, .xls, ,.csv'
            beforeUpload={()=>false}
            onChange={({ fileList: newFileList }) => setfileList(newFileList)}
            fileList={fileList}
          >
            <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
        </Dragger>
          </Form.Item>
       < Form.Item
          wrapperCol={{
            offset: 11,
            span: 16,
          }}
        >
  
          <Button loading={loading}  type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
        </Form>
      ) }
      
      </div>
  )
}

export default AddIcon